/**
 * @file    Transactions.css
 *
 *          Stylesheet for the Transactions component.
 *
 * @author  Kevin Yu <kevin@distributive.network>
 * @date    March 2024
 */

#transactions {
  width: 100%;
  overflow-x: auto;
  margin-top: 1em;
  grid-row-start: 3;

  table {
    width: 100%;
    font-size: 0.95rem;
    font-variant-numeric: tabular-nums;
  }

  @media only screen and (max-width: 1280px) {
    table {
      min-width: 853px;
    }
  }

  table th,
  table td {
    padding: 10px;
    text-wrap: nowrap;
  }

  table tbody td {
    border-bottom: 1px solid #e5e5e5;
  }

  table thead th {
    border-bottom: 1px solid var(--content-hue-main);
    text-align: left;
    padding-bottom: 10px;
    font-weight: normal;
    position: relative;
    bottom: -1.4px;
  }

  table tbody tr:last-child td {
    border-bottom: none;
  }

  table tfoot td {
    border-bottom: 1px solid var(--content-hue-main);
    border-top: 1px solid var(--content-hue-main);
    background-color: var(--content-hue-bg);
  }


  table td:nth-child(3) {
    overflow-x: hidden;
  }

  table td:nth-child(4),
  table th:nth-child(4),
  table td:nth-child(5),
  table th:nth-child(5) {
    text-align: right;
  }

  table tfoot td:nth-child(1) {
    font-weight: bold;
  }

  .transaction-balance {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  thead th button.ascending::after {
    content: "▲";
    display: inline;
    padding-left: 3px;
    font-weight: lighter;
    color: var(--content-hue-light);
  }

  thead th button.descending::after {
    content: "▼";
    display: inline;
    padding-left: 3px;
    font-weight: lighter;
    color: var(--content-hue-light);
  }

  thead th button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    text-align: left;
  }

  .transactions-table-no-data {
    width: 100%;
    text-align: center;
  }

  #transactions-dcc {
    min-width: 12px;
    width: 12px;
    height: 12px;
    position: relative;
    top: 1.5px;
    color: var(--content-hue-lighter);
  }

  .transactions-total,
  .transactions-table-credits {
    display: flex;
    justify-content: end;
    align-items: top;
    gap: 5px;
  }


  .dcc {
    color: var(--content-hue-main);

    &:hover {
      box-shadow: 0 -1.5px 0 var(--content-hue-main) inset;
    }
    
    img {
      filter: var(--content-hue-main-filter);
    }

  }

  .dcc::after {
    background-color: var(--content-hue-main);
  }
}
